// src/pages/Emails/EmailRightDrawer.tsx
import React from "react";
import { useTheme } from "@mui/material/styles";
import ActionOnRecord from "components/Records/ActionOnRecord";
import { moveItemsBetweenNodes } from "api/Campaigns/CampaignAPI";
import { getLinkedPeopleFromInteraction } from "api/Interactions/InteractionAPI";

interface EmailRightDrawerProps {
  emailId: number;
}

const EmailRightDrawer: React.FC<EmailRightDrawerProps> = ({
  emailId,
}) => {
  const theme = useTheme();

  // --------------------------------------------------
  // Fetch people attached to the Email interaction
  // --------------------------------------------------
  const fetchPeople = async () => {
    const people = await getLinkedPeopleFromInteraction("email_outreach", emailId);
    
    return people.map((p: any) => ({
      id: p.id,
      primary: `${p.first_name} ${p.last_name}`,
      secondary: p.email,
    }));
  };

  // --------------------------------------------------
  // Send emails = move people forward through pathway
  // --------------------------------------------------
  const handleSendEmails = async (selected: any[]) => {
    if (!selected.length) return;

    await moveItemsBetweenNodes({
      item_field_name: "people",
      selected_items: selected.map(p => p.id),
      handle_name: "output-10",
      direction: "forward",
      interaction_id: emailId,
      interaction_type: "email_outreach", 
    });

  };

  return (
    <ActionOnRecord
      fetchData={fetchPeople}
      onAction={handleSendEmails}
      primaryColor={theme.custom.modules.interactions.primary.dark}
      textColor={theme.custom.base.text.primary.dark}
      actionLabel="Log Emails"
    />
  );
};

export default EmailRightDrawer;
